const TOKEN_KEY = 'vexoura.session';

export class ApiClient {
  constructor(baseUrl = '/api') {
    this.baseUrl = baseUrl.replace(/\/$/, '');
    this.token = localStorage.getItem(TOKEN_KEY) || '';
  }

  async request(method, path, body) {
    const response = await fetch(`${this.baseUrl}${path}`, {
      method,
      headers: {
        ...(body === undefined ? {} : { 'Content-Type': 'application/json' }),
        ...(this.token ? { Authorization: `Bearer ${this.token}` } : {})
      },
      body: body === undefined ? undefined : JSON.stringify(body)
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.error || 'VEXOURA ist gerade nicht erreichbar.');
    return payload;
  }

  async authenticate(path, body) {
    const result = await this.request('POST', path, body);
    this.token = result.token;
    localStorage.setItem(TOKEN_KEY, this.token);
    return result;
  }

  async blob(path) {
    const response = await fetch(`${this.baseUrl}${path}`, {
      headers: this.token ? { Authorization: `Bearer ${this.token}` } : {}
    });
    if (!response.ok) throw new Error('Medium ist nicht verfügbar.');
    return response.blob();
  }

  logoutLocal() {
    this.token = '';
    localStorage.removeItem(TOKEN_KEY);
  }
}
